var options = {
  url: {
    landing: '/search',
    protocol: 'https:',
    search: 'https://uscs35v2.ksearchnet.com/cs/v2/search', // your Klevu APIv2 Search URL + endpoint path
  },
  search: {
    minChars: 0,
    searchBoxSelector: '#cmdk-input', // your search input selector
    apiKey: window?.klevu_api_key, // your Klevu JS API Key
    hlStartElem: '<span class="font-medium">',
    hlEndElem: '</span>',
  },
  analytics: {
    apiKey: window?.klevu_api_key, // your Klevu JS API Key
  },
  theme: {
    setHelpers: {
      all: {
        getLocalizedUrl: function (originalUrl) {
          try {
            if (!originalUrl) return '';
            const currentOrigin = window.location.origin;
            const urlObj = new URL(originalUrl);
            return currentOrigin + urlObj.pathname + urlObj.search;
          } catch (e) {
            return originalUrl;
          }
        },
      },
      landing: {
        customSortResultsLabel: function (dataLocal) {
          let selectedText = '';

          switch (dataLocal) {
            case 'productList':
              selectedText = 'Product';
              break;
            case 'contentList':
              selectedText = 'Article';
              break;
          }
          return selectedText;
        },
        customSortBy: function (dataLocal) {
          /* sets the selected option to the display */

          var selectedText = '';

          var klevuStorage = klevu.getSetting(
            klevu.settings,
            'settings.storage',
          );

          switch (
            klevuStorage.sort.getElement(dataLocal) == dataLocal
              ? 'RELEVANCE'
              : klevuStorage.sort.getElement(dataLocal)
          ) {
            case 'RELEVANCE':
              selectedText = 'Relevance';
              break;
            case 'PRICE_ASC':
              selectedText = 'Price: Low to high';
              break;
            case 'PRICE_DESC':
              selectedText = 'Price: High to low';
              break;
            case 'NAME_ASC':
              selectedText = 'Name: A to Z';
              break;
            case 'NAME_DESC':
              selectedText = 'Name: Z to A';
              break;
            case 'NEW_ARRIVAL_DESC':
              selectedText = 'Latest';
              break;
            case 'NEW_ARRIVAL_ASC':
              selectedText = 'Oldest';
              break;
            default:
              console.log('INSIDE THIS ONE');
              selectedText = 'Relevance';
          }
          return selectedText;
        },
      },
    },
  },
};
klevu(options);

klevu.ready(() => {
  const containers = [...document.querySelectorAll('.klevuTarget')];
  const backdrop = document.getElementById('backdrop');
  const main = document.getElementById('MainContent');
  const searchBox = document.getElementById('cmdk-input');

  klevu.afterTemplateRender('quick', () => {
    window.matchHeights();
  });

  const config = {
    attributes: true,
    attributeFilter: ['style'],
  };

  const callback = function (mutationsList) {
    for (const mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'style'
      ) {
        const style = mutation.target.style;
        if (style.display == 'block') {
          backdrop?.classList?.remove('tw-backdrop-hidden');
        } else if (style.display == 'none') {
          backdrop?.classList?.add('tw-backdrop-hidden');
        }
      }
    }
  };

  const observer = new MutationObserver(callback);

  const desktopQuery = window.matchMedia('(min-width: 1280px)');

  const handleScroll = (event) => {
    debounce(() => {
      if (event.deltaY > 1 || event.deltaY < -1) {
        main?.click();
        searchBox?.blur();
      }
    }, 5)();
  };

  desktopQuery.addEventListener('change', (mediaQuery) => {
    if (mediaQuery.matches) {
      window.addEventListener('wheel', handleScroll);

      containers.forEach((container) => {
        observer.observe(container, config);
      });
    } else {
      window.removeEventListener('wheel', handleScroll);
      containers.forEach(() => {
        observer.disconnect();
      });
    }
  });

  if (desktopQuery.matches) {
    window.addEventListener('wheel', handleScroll);
    containers.forEach((container) => {
      observer.observe(container, config);
    });
  }
});
